<template functional>
  <div class="inline-flex align-center" :class="[data.staticClass, data.class]">
    <RouterLink class="inline-flex align-center" :to="`/profile/${props.address}`">
      <MtxBlockie :input="props.address" :options="{ scale: 3 }" />
      <div class="ml-1">{{ props.address | ethAddress }}</div>
    </RouterLink>

    <Copy class="ml-1" v-if="props.copy" plain :text="props.address" />
  </div>
</template>

<script>
export default {
  props: {
    address: {
      type: String,
      required: true
    },

    copy: Boolean
  }
}
</script>
